import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { queryClient } from '@/lib/utils/queryClient';
import { myRequestsQueryOptions } from '../../../-hooks/useMyRequestsQuery';

export const Route = createFileRoute(
  '/(client)/questionnaires/(pages)/(list)/requests/',
)({
  loader: () =>
    queryClient.ensureQueryData(myRequestsQueryOptions({ page: 1, count: 50 })),
  component: lazyRouteComponent(
    () => import('../../../-components/RequestsTab'),
    'RequestsTab',
  ),
});
